import React, { useState } from 'react';
import { ArrowLeft, CheckCircle, Loader2, XCircle } from 'lucide-react';
import { Button } from '../../components/ui/Button';
import { Input } from '../../components/ui/Input';
import { Select } from '../../components/ui/Select';
import { Card } from '../../components/ui/Card';
interface BranchFormProps {
  onCancel: () => void;
  onSubmit: () => void;
}
export function BranchForm({
  onCancel,
  onSubmit
}: BranchFormProps) {
  const [isValidating, setIsValidating] = useState(false);
  const [ibanValid, setIbanValid] = useState<boolean | null>(null);
  const [ibanTitle, setIbanTitle] = useState('');
  const [formData, setFormData] = useState({
    branchName: '',
    city: '',
    region: '',
    address: '',
    email: '',
    phone: '',
    iban: ''
  });
  const handleValidateIban = () => {
    if (formData.iban.length !== 24) return;
    setIsValidating(true);
    setTimeout(() => {
      setIsValidating(false);
      setIbanValid(true);
      setIbanTitle(`CDNS ${formData.city.toUpperCase()} OPS`);
    }, 1500);
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit();
  };
  return <div className="space-y-6 max-w-3xl mx-auto" data-id="element-158">
      <div className="flex items-center space-x-4" data-id="element-159">
        <Button variant="ghost" onClick={onCancel} data-id="element-160">
          <ArrowLeft className="w-5 h-5 mr-2" data-id="element-161" />
          Back
        </Button>
        <h2 className="text-2xl font-bold text-gray-900" data-id="element-162">Add New Branch</h2>
      </div>

      <form onSubmit={handleSubmit} data-id="element-163">
        <Card className="space-y-6" data-id="element-164">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-165">
            <Input label="Branch Code" value="AUTO-GENERATED" disabled className="bg-gray-50" data-id="element-166" />
            <Input label="Branch Name" required value={formData.branchName} onChange={e => setFormData({
            ...formData,
            branchName: e.target.value
          })} data-id="element-167" />

            <Select label="City" placeholder="Select City" options={[{
            value: 'Islamabad',
            label: 'Islamabad'
          }, {
            value: 'Lahore',
            label: 'Lahore'
          }, {
            value: 'Karachi',
            label: 'Karachi'
          }, {
            value: 'Peshawar',
            label: 'Peshawar'
          }, {
            value: 'Quetta',
            label: 'Quetta'
          }]} value={formData.city} onChange={e => setFormData({
            ...formData,
            city: e.target.value
          })} required data-id="element-168" />

            <Select label="Region" placeholder="Select Region" options={[{
            value: 'Federal',
            label: 'Federal'
          }, {
            value: 'Punjab',
            label: 'Punjab'
          }, {
            value: 'Sindh',
            label: 'Sindh'
          }, {
            value: 'KPK',
            label: 'KPK'
          }, {
            value: 'Balochistan',
            label: 'Balochistan'
          }]} value={formData.region} onChange={e => setFormData({
            ...formData,
            region: e.target.value
          })} required data-id="element-169" />

            <Input label="Email Address" type="email" required value={formData.email} onChange={e => setFormData({
            ...formData,
            email: e.target.value
          })} data-id="element-170" />
            <Input label="Phone Number" required placeholder="051-XXXXXXX" value={formData.phone} onChange={e => setFormData({
            ...formData,
            phone: e.target.value
          })} data-id="element-171" />
          </div>

          <div className="col-span-2" data-id="element-172">
            <label className="block text-sm font-medium text-gray-700 mb-1.5" data-id="element-173">
              Address
            </label>
            <textarea className="block w-full rounded-lg border border-gray-300 bg-white text-sm transition-colors px-3 py-2.5 placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-[#1B6B3A]/20 focus:border-[#1B6B3A] disabled:bg-gray-50 disabled:text-gray-400 disabled:cursor-not-allowed disabled:border-gray-200" rows={3} required value={formData.address} onChange={e => setFormData({
            ...formData,
            address: e.target.value
          })} data-id="element-174"></textarea>
          </div>

          <div className="border-t border-gray-200 pt-6" data-id="element-175">
            <h3 className="text-lg font-medium text-gray-900 mb-4" data-id="element-176">
              IBAN Configuration
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 items-end" data-id="element-177">
              <Input label="Branch IBAN (24 Digits)" placeholder="PK36CDNS0000000000000000" maxLength={24} className="font-mono uppercase" value={formData.iban} onChange={e => setFormData({
              ...formData,
              iban: e.target.value.toUpperCase()
            })} required data-id="element-178" />
              <Button type="button" variant="secondary" onClick={handleValidateIban} disabled={formData.iban.length !== 24 || isValidating} isLoading={isValidating} data-id="element-179">
                Validate IBAN
              </Button>
            </div>

            {ibanValid !== null && <div className={`mt-4 p-4 rounded-lg flex items-start ${ibanValid ? 'bg-green-50 border border-green-200' : 'bg-red-50 border border-red-200'}`} data-id="element-180">
                {ibanValid ? <CheckCircle className="w-5 h-5 text-green-600 mt-0.5 mr-3" data-id="element-181" /> : <XCircle className="w-5 h-5 text-red-600 mt-0.5 mr-3" data-id="element-182" />}
                <div data-id="element-183">
                  <h4 className={`text-sm font-medium ${ibanValid ? 'text-green-800' : 'text-red-800'}`} data-id="element-184">
                    {ibanValid ? 'IBAN Validated Successfully' : 'Invalid IBAN'}
                  </h4>
                  {ibanValid && <p className="text-sm text-green-700 mt-1" data-id="element-185">
                      Account Title:{' '}
                      <span className="font-bold" data-id="element-186">{ibanTitle}</span>
                    </p>}
                </div>
              </div>}
          </div>

          <div className="flex justify-end space-x-3 pt-4" data-id="element-187">
            <Button type="button" variant="outline" onClick={onCancel} data-id="element-188">
              Cancel
            </Button>
            <Button type="submit" disabled={!ibanValid} data-id="element-189">
              Submit for Approval
            </Button>
          </div>
        </Card>
      </form>
    </div>;
}